import { useState } from "react";
import { HOSTS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function Hosts() {
  const [follows, setFollows] = useState<Record<string, boolean>>({});

  return (
    <section id="hosts" className="relative scroll-mt-20 overflow-hidden bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="人气主播"
            title={
              <>
                跟对人，<span className="text-accent-700">天天有新瓜</span>
              </>
            }
            desc="会聊、敢说、有分寸。关注你喜欢的麦主，开播第一时间提醒，回放直播都不错过。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {HOSTS.map((h, idx) => {
            const isFollowed = !!follows[h.name];
            return (
              <Reveal key={h.name} delay={(idx % 4) * 70}>
                <article className="group h-full rounded-3xl border border-background-200 bg-background-50 p-6 text-center transition hover:-translate-y-1 hover:border-accent-300">
                  <div className="relative mx-auto h-24 w-24">
                    <img
                      src={h.avatar}
                      alt={`吃瓜快手人气主播${h.name}`}
                      className="h-24 w-24 rounded-full object-cover ring-4 ring-primary-100"
                    />
                    <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-foreground-950">
                      {h.style}
                    </span>
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-foreground-950">{h.name}</h3>
                  <p className="mt-1.5 min-h-[42px] text-sm leading-6 text-foreground-600">{h.desc}</p>
                  <p className="mt-2 text-xs text-foreground-500">
                    <i className="ri-user-follow-line mr-1 text-primary-600" />
                    {h.followers} 粉丝
                  </p>
                  <button
                    type="button"
                    onClick={() => setFollows((p) => ({ ...p, [h.name]: !p[h.name] }))}
                    className={`mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-semibold transition whitespace-nowrap ${
                      isFollowed
                        ? "bg-accent-100 text-accent-800 hover:bg-accent-200"
                        : "bg-primary-500 text-foreground-950 hover:bg-primary-600"
                    }`}
                  >
                    <i className={isFollowed ? "ri-check-double-line" : "ri-add-line"} />
                    {isFollowed ? "已关注 · 开播提醒" : "关注主播"}
                  </button>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}